import { WidgetViews, type WidgetApps } from '@/types'
import { markRaw, type Component, defineAsyncComponent, type AsyncComponentLoader } from 'vue'

import Processing from '@/views/Processing.vue'
import Loading from '@/views/Loading.vue'
import Error from '@/views/Error.vue'
import CloseWidget from '@/views/CloseWidget.vue'

const getAsyncComponentConfig = (loader: AsyncComponentLoader) => defineAsyncComponent({
    loader,
    loadingComponent: Loading,
    delay: 300,
})

// Preload custom page chunk in next macrotask — yields to websocket init first, then loads in parallel
const customPagePromise = new Promise<typeof import('@/views/apps/_customPage/Start.vue')>(resolve => {
    setTimeout(() => resolve(import('@/views/apps/_customPage/Start.vue')), 0)
})

export const widgetViews: Record<WidgetViews | WidgetApps, Component> = {
    [WidgetViews.PROCESSING]: markRaw(Processing),
    [WidgetViews.LOADING]: markRaw(Loading),
    [WidgetViews.ERROR]: markRaw(Error),
    [WidgetViews.CLOSE_WIDGET]: markRaw(CloseWidget),
    [WidgetViews.CUSTOM_PAGE_PREVIEW]: getAsyncComponentConfig(() => customPagePromise),
    'custom-page': getAsyncComponentConfig(() => customPagePromise),
    'workflow-finish': getAsyncComponentConfig(() => import('@/views/WorkflowFinish.vue')),
    'zoho-sign': getAsyncComponentConfig(() => import('@/views/apps/zoho-sign/Index.vue')),
    'transactionlink-open-banking': getAsyncComponentConfig(() => import('@/views/apps/transactionlink-open-banking/Index.vue')),
    'veriff-video-verification': getAsyncComponentConfig(() => import('@/views/apps/veriff-video-verification/Index.vue')),
    veriff: getAsyncComponentConfig(() => import('@/views/apps/veriff/Index.vue')),
    'veriff-age-estimation': getAsyncComponentConfig(() => import('@/views/apps/veriff-age-estimation/Index.vue')),
    twilio: getAsyncComponentConfig(() => import('@/views/apps/twilio/Index.vue')),
    'ondato-vv': getAsyncComponentConfig(() => import('@/views/apps/ondato-video-verification/Index.vue')),
    'moje-id-verification': getAsyncComponentConfig(() => import('@/views/apps/moje-id-verification/Index.vue')),
    'gbg-id-verification': getAsyncComponentConfig(() => import('@/views/apps/gbg-id-verification/Index.vue')),
    'autopay-verification-payment': getAsyncComponentConfig(() => import('@/views/apps/autopay-verification-payment/Index.vue')),
    'mobywatel-id-verification': getAsyncComponentConfig(() => import('@/views/apps/mobywatel-id-verification/Index.vue')),
    'au10tix-video-verification': getAsyncComponentConfig(() => import('@/views/apps/au10tix-video-verification/Au10tixVideoVerification.vue')),
}

export const viewsKeys = Object.keys(widgetViews)
